import Mmenu from 'mmenu-js';
import 'mburger-webcomponent/dist/mburger/index';

export default function initializeMobileMenu() {

    new Mmenu( '#mobile-menu', {
        theme: 'grey',
    } );

    // const header = document.querySelector('.header');
    // const scrollElement = document.querySelector('.header__scroll');
    //
    // let maxHeight = 100;
    //
    // window.addEventListener('scroll', function() {
    //     if (window.scrollY > 0) {
    //         if (scrollElement.offsetHeight < maxHeight) {
    //             scrollElement.style.height = Math.min(window.scrollY / 2, maxHeight) + '%';
    //         }
    //         if (scrollElement.offsetHeight > maxHeight){
    //             header.classList.add('header--fixed');
    //             scrollElement.style.zIndex = '-1';
    //         }
    //     } else {
    //         header.classList.remove('header--fixed');
    //         scrollElement.style.height = '0';
    //         scrollElement.style.zIndex = '3';
    //     }
    // });
}
